import { render, staticRenderFns } from "./CollectionListComponent.vue?vue&type=template&id=5f35e04a&scoped=true&"
import script from "./CollectionListComponent.vue?vue&type=script&lang=js&"
export * from "./CollectionListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35e04a",
  null
  
)

export default component.exports